'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.multipartUpload = multipartUpload;
exports.checkStatus = checkStatus;
exports.catchError = catchError;
exports.makeRequest = makeRequest;

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Serialize a query to a valid URL query string
var qs = function qs() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(query).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return key + '=' + encodeURIComponent(value);
  }).join('&');
};

function multipartUpload(file, path) {
  var progress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  return new Promise(function (resolve, reject) {
    var form = new FormData();
    form.append('file', file);

    var xhr = new XMLHttpRequest();
    xhr.addEventListener('error', function (e) {
      return reject(e);
    });
    xhr.addEventListener('abort', function (e) {
      return reject(e);
    });
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        resolve(JSON.parse(xhr.responseText));
      }
    };
    xhr.upload.addEventListener('progress', progress);
    xhr.open('POST', path);
    xhr.send(form);
  });
}

/**
 * Checks a response status code and returns a new Promise with the parsed JSON
 * response. In case of an error, an exception is raised.
 */
function checkStatus(response) {
  return response.json().then(function (body) {
    if (response.ok) {
      return { response: response, body: body };
    }
    throw { response: response, body: body };
  }).catch(function (err) {
    return catchError(err, response);
  });
}

function catchError(err, response) {
  if (process.browser && window.stackDriver) {
    window.stackDriver.report(err);
  }

  throw { err: err, response: response };
}

function makeRequest(_ref3) {
  var url = _ref3.url,
      path = _ref3.path,
      _ref3$query = _ref3.query,
      query = _ref3$query === undefined ? {} : _ref3$query,
      _ref3$options = _ref3.options,
      options = _ref3$options === undefined ? {} : _ref3$options;

  url = '' + url + path + '?' + qs(query);

  options = Object.assign({
    credentials: 'same-origin',
    method: 'GET'
  }, options, {
    headers: Object.assign({
      'Content-Type': 'application/json'
    }, options.headers)
  });

  var _options = options,
      method = _options.method,
      body = _options.body;

  if (method !== 'GET' && (0, _isObject2.default)(body)) {
    options.body = JSON.stringify(body);
  }

  // Use window.fetch on the browser so that 3rd party libraries can instrument
  // fetch based requests.
  var func = process.browser && window.fetch || _isomorphicFetch2.default;
  return func(url, options).then(checkStatus);
}